/* Index_object_testimonials_marquee */
initMarquee('.Index_object_testimonials_marquee', {
    mobile: {
        duration: 50000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});
/* Index_object_testimonials_marquee */

document.querySelectorAll('.Index_object_testimonials_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: true,
        grabCursor: true,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                spaceBetween: 16,
            },
            750: {
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});


const playlist = document.querySelector(".video_play_list");

/* MUTE ALL */
function muteAllVideos() {

  if (!playlist) return;

  playlist.querySelectorAll(".full_video_new").forEach(function (item) {

    const video     = item.querySelector('video');
    const muteBtn   = item.querySelector('.mute_video');
    const unmuteBtn = item.querySelector('.unmute_video');

    if (!video || !muteBtn || !unmuteBtn) return;   // null guard

    video.muted = true;
    muteBtn.classList.remove('active');
    unmuteBtn.classList.add('active');

  });

}


/* VIDEO BUTTON CONTROLS (EVENT DELEGATION) */

if (playlist) {

  playlist.addEventListener("click", function (e) {

    const muteBtn = e.target.closest(".mute_video");
    const unmuteBtn = e.target.closest(".unmute_video");

    if (!muteBtn && !unmuteBtn) return;

    const parent = e.target.closest(".full_video_new");
    const video = parent.querySelector("video");
    const mute = parent.querySelector(".mute_video");
    const unmute = parent.querySelector(".unmute_video");

    /* MUTE BUTTON */
    if (muteBtn) {

      video.muted = true;

      mute.classList.remove("active");
      unmute.classList.add("active");

    }

    /* UNMUTE BUTTON */
    if (unmuteBtn) {

      const wasPlaying = !video.paused;

      /* MUTE OTHER VIDEOS ONLY */
      playlist.querySelectorAll("video").forEach(function (v) {
        if (v !== video) v.muted = true;
      });

      playlist.querySelectorAll(".full_video_new").forEach(function (item) {

        if (item !== parent) {

          item.querySelector(".mute_video").classList.remove("active");
          item.querySelector(".unmute_video").classList.add("active");

        }

      });

      video.muted = false;

      unmute.classList.remove("active");
      mute.classList.add("active");

      /* SAFARI STABILITY FIX */
      if (wasPlaying) video.play();

    }

  });

}


/* Video List End */